"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dom_node_type_1 = require("dom-node-type");

var node_text_1 = require("./node-text");

var Replacement_1 = require("./Replacement");

var Replacer_1 = require("./Replacer");

var SinglyLinkedList_1 = require("./SinglyLinkedList");

function withinElement(element, _a) {
  var flag = _a.flag,
      find = _a.find,
      replace = _a.replace;
  var textNodesDividedByBlock = node_text_1.getTextNodesDividedByBlock(element);
  var recovers = textNodesDividedByBlock.map(function (textNodes) {
    var _a = node_text_1.getTextWithRanges(textNodes),
        oneLineOfText = _a.text,
        ranges = _a.ranges;

    var regex = new RegExp(find, flag);
    var map = new Map();
    var singlyLinkedList = new SinglyLinkedList_1.SinglyLinkedList();
    var regexpExecResult = regex.exec(oneLineOfText);

    if (!regexpExecResult) {
      return null;
    }

    while (regexpExecResult) {
      if (!regexpExecResult[0]) {
        break;
      }

      var regexpStartIndex = regexpExecResult.index;

      var _b = __read(regexpExecResult, 1),
          foundText = _b[0];

      var regexpEndIndex = regexpStartIndex + foundText.length;
      var copyOfReplaceText = typeof replace === 'string' ? replace : '';
      var copyOfFoundText = typeof replace === 'string' ? foundText : '';
      var slicedReplaceText = '';

      for (var i = 0; i < ranges.length; i++) {
        var _c = ranges[i],
            textNode = _c.textNode,
            _d = _c.range,
            start = _d.start,
            end = _d.end;
        var replacement = new Replacement_1.Replacement(textNode.nodeValue, foundText);

        if (start >= regexpStartIndex && start < regexpEndIndex) {
          replacement.range = {
            start: start,
            end: end < regexpEndIndex ? end : regexpEndIndex
          };
        } else if (end > regexpStartIndex && end <= regexpEndIndex) {
          replacement.range = {
            start: start < regexpStartIndex ? regexpStartIndex : start,
            end: end
          };
        } else if (regexpStartIndex >= start && regexpStartIndex < end) {
          replacement.range = {
            start: regexpStartIndex,
            end: end < regexpEndIndex ? end : regexpEndIndex
          };
        } else if (regexpEndIndex > start && regexpEndIndex <= end) {
          replacement.range = {
            start: start < regexpStartIndex ? regexpStartIndex : start,
            end: regexpEndIndex
          };
        } else if (start === regexpStartIndex && end === regexpEndIndex) {
          replacement.range = {
            start: start,
            end: end
          };
        } else {
          continue;
        }

        replacement.range = {
          start: replacement.range.start - start,
          end: replacement.range.end - start
        };

        if (typeof replace === 'string') {
          var range = replacement.range;
          slicedReplaceText = copyOfReplaceText.slice(0, range.end - range.start);
          copyOfReplaceText = copyOfReplaceText.slice(range.end - range.start);
          copyOfFoundText = copyOfFoundText.slice(range.end - range.start);

          if (!copyOfFoundText && copyOfReplaceText.length > 0) {
            slicedReplaceText = "" + slicedReplaceText + copyOfReplaceText;
            copyOfReplaceText = '';
          }

          replacement.replaceFunction = function (slicedReplaceText) {
            return function () {
              return document.createTextNode(slicedReplaceText);
            };
          }(slicedReplaceText);
        } else {
          replacement.replaceFunction = replace;
        }

        var replacer_1 = map.get(textNode);

        if (!replacer_1) {
          replacer_1 = new Replacer_1.Replacer(textNode);
          singlyLinkedList.add(replacer_1);
          map.set(textNode, replacer_1);
        }

        replacer_1.addReplacement(replacement);
      }

      regexpExecResult = regex.exec(oneLineOfText);
    }

    var replacer = singlyLinkedList.head;

    while (replacer) {
      replacer.replace();
      replacer = replacer.next;
    }

    return function () {
      var replacer = singlyLinkedList.head;

      while (replacer) {
        replacer.recover();
        replacer = replacer.next;
      }
    };
  });
  return function () {
    return recovers.forEach(function (recover) {
      return recover && recover();
    });
  };
}

function withinHTML(html, options) {
  var element = document.createElement('div');
  element.innerHTML = html;
  withinElement(element, options);
  return element.innerHTML;
}

function findAndReplace(target, options) {
  var optionsWithDefault = Object.assign({}, {
    flag: 'g'
  }, options);

  if (typeof target === 'string') {
    return withinHTML(target, optionsWithDefault);
  } else if (dom_node_type_1.isElementNode(target)) {
    return withinElement(target, optionsWithDefault);
  } else {
    return null;
  }
}

exports.default = findAndReplace;